(function () {
    'use strict';

    angular
        .module('sodCommon')
        .filter('contains', contains);

    function contains() {
        return function (value) {
            var arr = Array.prototype.slice.call(arguments, 1);
            return arr.indexOf(value) > -1;
        };
    }
})();